import { NgModule } from '@angular/core';
import { WebappnotificationComponent } from './webappnotification.component';
import { BrowserModule } from '@angular/platform-browser';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgBoostedModule } from 'ng-boosted';
import { WebappnotificationRoutingModule} from './webappnotificationrouting.module';
import { WebSocketServiceService } from './webappnotification.service';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {ToastrModule } from 'ngx-toastr';

//this for badge notification
import {MatBadgeModule, MatButtonModule, MatIconModule} from '@angular/material'
import {FormsModule, ReactiveFormsModule} from '@angular/forms';



@NgModule({
  declarations: [WebappnotificationComponent],
  imports: [
    WebappnotificationRoutingModule,
    BrowserModule,  
    NgbModule,
    FormsModule,
    MatBadgeModule, MatButtonModule, MatIconModule,
    NgBoostedModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    ToastrModule.forRoot({
      timeOut: 40000,
      positionClass: 'toast-bottom-right',
      preventDuplicates : true,
    })
   
  ],
  providers: [WebSocketServiceService],
  exports: [WebappnotificationComponent]
  
})
export class WebappnotificationModule { }
